import { Component } from "react"

/* Link */
import { Link, NavLink } from "react-router-dom"

/* Components */
import Icon from "./Icon"

/* Constants */
import { menu } from "../constants"


/* Component Menu — the sidebar of the panel. It folds down to the icons alone, and then the
   captions of the sections turn into thin lines and every row keeps its name as a tooltip.
   The button which folds it is the last row of the sidebar */
class Menu extends Component {

    render = () => {

        /* Fields */
        const { minimized, toggle } = this.props

        return (
            <div className={`menu ${minimized ? "minimized" : ""}`}>

                <div className="menu-inner">

                    <Link to="/" className="menu-logo">

                        <img className="menu-logo-mark" src="/images/logo.png" alt="Bookify" />

                        <div className="menu-logo-text">
                            <div className="menu-logo-name">BOOKIFY</div>
                            <div className="menu-logo-subtext">Админ-панель</div>
                        </div>

                    </Link>

                    <div className="menu-box">
                        {menu.data.map((item, index) => {

                            /* The caption of a section */
                            if (item.section) {
                                return <div className="menu-section" key={`${index}`}><span>{item.section}</span></div>
                            }

                            return (
                                <NavLink key={`${index}`} to={item.link} end={item.link === "/"} title={item.text} className="menu-item">
                                    <div className="menu-image">
                                        <Icon name={item.icon} size={21} />
                                    </div>
                                    <span>{item.text}</span>
                                </NavLink>
                            )
                        })}
                    </div>

                    <div className="menu-footer">
                        <div onClick={() => toggle()} title={minimized ? "Развернуть меню" : "Свернуть меню"} className="menu-item menu-fold">
                            <div className="menu-image">
                                <Icon name={minimized ? "sidebarOpen" : "sidebarClose"} size={21} />
                            </div>
                            <span>Свернуть меню</span>
                        </div>
                    </div>

                </div>

            </div>
        )
    }
}

export default Menu
